import type React from 'react';

export interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  className?: string;
}

export function Form({ className, ...props }: FormProps): JSX.Element {
  return (
    <form
      className={['entity-form', className].filter(Boolean).join(' ')}
      {...props}
    />
  );
}
